/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import Colors from 'constants/Colors';
import Loader from 'components/Loader';
import { Label } from "components/Form";
import { Row, Col } from "components/Grid";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import StepNavigation from "components/StepNavigation";
import BrokingSummary from "components/BrokingSummary";
import ClaimsSummary from 'components/ClaimsSummary';
import Button, { ButtonContainer } from 'components/Button';
import MasksHelper from 'utils/src/masks';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalLoaderContext } from 'store/context';
import ComboBox3 from 'components/Form/ComboBox3';
import { InputField } from "components/Form/index";
import { RadioButton } from "components/Form/Radio/index";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";
import { GridColumnTitle } from "components/Form";
import * as yup from 'yup';
import {
  Label1,
  CalendarContainer,
  ButtonContent,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  InlineLabel,
  LabelEdit,
} from "./styles";
import { useHeaderNbi, useProcessingPeriodsSchedule, useInsurerTaxes } from 'services/QuoteService';
import { usePaymentConfigurationForm, useFxRates, useGeneratePaymentPackStatus, useSavePaymentConfigurationForm, useGeneratePaymentPackV2, useExpirePaymentPack } from 'services/PaymentPackService';
import { useOperationInfo } from 'services/OperationService';
import { usePersonList } from 'services/PersonService';
import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import {
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswer,
  useDeleteQuestionnaireAnswerAsync,
  useSyncQuestionnaireAnswer
} from '@fitinsur/services/QuestionnaireAnswerService';
import { handleQuestionChange, handleQuestionsInitialAdjustments } from "./handleQuestionChange";
import { onValidationError } from './utils';
import PremiumCalculationSection from "components/PremiumCalculationSection/index";
import { QUESTIONS } from "../contractBuilder/utils";
import { TaxCalculationSection } from "./sections/index";
import { cloneDeep } from "lodash";

import FormContainer from "components/FormContainer";
import { sortBy as _sortBy } from "lodash";
import { TaxesRatesBasisGroupSection } from '../marketComposition/sections/index'
import { LostCancelButton } from 'components/index';

export default function PaymentConfiguration(props) {
  const maskHelper = new MasksHelper();
  const [summary, setSummary] = useState({});
  const [fullyLoaded, setFullyLoaded] = useState(false);
  const authContext = useContext(GlobalAuthContext);
  const [questions, setQuestions] = useState([]);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [questionnaireAux, setQuestionnaireAux] = useState([]);

  const [endorsementType, setEndorsementType] = useState("");
  const [periods, setPeriods] = useState([]);
  const [currentPeriod, setCurrentPeriod] = useState(undefined);
  const [isMas, setIsMas] = useState(false);
  const [isSingapureOffice, setIsSingapureOffice] = useState(false);
  const [isThirdParty, setIsThirdParty] = useState(null);
  const [isNewYork, setIsNewYork] = useState(false);
  const [facilities, setFacilities] = useState([]);
  const [statusEndorsement, setStatusEndorsement] = useState({
    title: "Payment Configuration",
    route: "",
  });
  const [hasPremiumCalculation, setHasPremiumCalculation] = useState(false);

  const [showCalendar, setShowCalendar] = useState('');
  const [searchList, setSearchList] = useState();

  const formik = useRef(null);
  const history = useHistory();
  const mc = new MessageCenter();
  const fitinsur = new FitinsurAPI();
  const loading = useContext(GlobalLoaderContext);
  const masks = new MasksHelper();
  const isPaymentPackButtonClicked = useRef(false)

  // criando variavel para utilizar no useeffect uma vez que o handleSchedullePeriods é chamado antes de o state do summary ser setado, inviabilizando o uso do summary.isFramework
  const [isFramework, setIsFramework] = useState(true);
  const [isClaims, setIsClaims] = useState(false);
  const [hasLloydsOrLirma, setHasLloydsOrLirma] = useState(false);
  const [isAbleToGeneratePaymentPack, setIsAbleToGeneratePaymentPack] = useState(false);
  const [statusIsLoading, setStatusIsLoading] = useState(false);
  const currentOsnd = useRef({});
  const [taxes, setTaxes] = useState([]);
  const [operation, setOperation] = useState(null);
  const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]); // mesma do composition (globais)
  const [insurerGroup, setInsurerGroup] = useState([]);
  const [feePayableByGroup, setFeePayableByGroup] = useState([]);
  const [isTaxesLoading, setTaxesLoading] = useState(false);
  const [isBound, setIsBound] = useState(false);
  const [canCancel, setCanCancel] = useState(false);

  const SECTIONS = {
    PAYMENT_CONFIG: { name: 'PAYMENT_CONFIG', isMultiple: false, isRisk: false },
    TAX_CALCULATION: { name: 'TAX_CALCULATION', isMultiple: true, isRisk: false },
    TAX_RATES: { name: "TAX_RATES", isMultiple: false, isRisk: false },
    INSURER_TAXES: { name: "INSURER_TAXES", isMultiple: true, isRisk: false },
    FEE_PAYABLE_BY: { name: "FEE_PAYABLE_BY", isMultiple: true, isRisk: false },
  };

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: usePaymentConfigurationFormData,
    loading: usePaymentConfigurationFormLoading,
    error: usePaymentConfigurationFormError,
    status: usePaymentConfigurationFormStatus,
    request: usePaymentConfigurationFormRequest,
  } = usePaymentConfigurationForm(props.match.params.idOperation);

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: usePersonListData,
    loading: usePersonListLoading,
    error: usePersonListError,
    status: usePersonListStatus,
    request: usePersonListRequest,
  } = usePersonList();

  const {
    data: useProcessingPeriodsScheduleData,
    loading: useProcessingPeriodsScheduleLoading,
    error: useProcessingPeriodsScheduleError,
    status: useProcessingPeriodsScheduleStatus,
    request: useProcessingPeriodsScheduleRequest,
  } = useProcessingPeriodsSchedule(props.match.params.idOperation);

  const {
    data: useFxRatesData,
    loading: useFxRatesLoading,
    error: useFxRatesError,
    status: useFxRatesStatus,
    request: useFxRatesRequest,
  } = useFxRates();

  const {
    data: useGeneratePaymentPackStatusData,
    loading: useGeneratePaymentPackStatusLoading,
    error: useGeneratePaymentPackStatusError,
    status: useGeneratePaymentPackStatusStatus,
    request: useGeneratePaymentPackStatusRequest,
  } = useGeneratePaymentPackStatus(props.match.params.idOperation);

  const {
    data: useSavePaymentConfigurationFormData,
    loading: useSavePaymentConfigurationFormLoading,
    error: useSavePaymentConfigurationFormError,
    status: useSavePaymentConfigurationFormStatus,
    request: useSavePaymentConfigurationFormRequest,
  } = useSavePaymentConfigurationForm(props.match.params.idOperation);

  const {
    data: useGeneratePaymentPackV2Data,
    loading: useGeneratePaymentPackV2Loading,
    error: useGeneratePaymentPackV2Error,
    status: useGeneratePaymentPackV2Status,
    request: useGeneratePaymentPackV2Request,
  } = useGeneratePaymentPackV2();

  const {
    loading: useExpirePaymentPackLoading,
    request: useExpirePaymentPackRequest,
  } = useExpirePaymentPack(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  const {
    status: useDeleteQuestionnaireAnswerStatus,
    loading: useDeleteQuestionnaireAnswerLoading,
    request: useDeleteQuestionnaireAnswerRequest,
  } = useDeleteQuestionnaireAnswerAsync(props.match.params.idOperation);

  const {
    request: useSyncQuestionnaireAnswerRequest,
    loading: useSyncQuestionnaireAnswerLoading,
  } = useSyncQuestionnaireAnswer(props.match.params.idOperation);

  useEffect(() => {
    if (
      useHeaderNbiLoading ||
      usePaymentConfigurationFormLoading ||
      useOperationInfoLoading ||
      usePersonListLoading ||
      useProcessingPeriodsScheduleLoading ||
      useFxRatesLoading ||
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useGeneratePaymentPackV2Loading ||
      useGeneratePaymentPackStatusLoading ||
      statusIsLoading ||
      useExpirePaymentPackLoading ||
      useDeleteQuestionnaireAnswerLoading ||
      useSavePaymentConfigurationFormLoading ||
      useSyncQuestionnaireAnswerLoading ||
      isTaxesLoading
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [
    useHeaderNbiLoading,
    usePaymentConfigurationFormLoading,
    useOperationInfoLoading,
    usePersonListLoading,
    useProcessingPeriodsScheduleLoading,
    useGetQuestionnairesAnswersLoading,
    useFxRatesLoading,
    useSaveQuestionnaireAnswerLoading,
    useGeneratePaymentPackV2Loading,
    useGeneratePaymentPackStatusLoading,
    statusIsLoading,
    useExpirePaymentPackLoading,
    useDeleteQuestionnaireAnswerLoading,
    useSavePaymentConfigurationFormLoading,
    useSyncQuestionnaireAnswerLoading,
    isTaxesLoading
  ]);


  // useEffect(() => {
  //   if (!fullyLoaded) loading.start();
  // }, [fullyLoaded, loading])

  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        nmObligor: data.ret_value.nmObligor,
        isFramework: data.ret_value.isFramework,
        projectName: data.ret_value.projectName,
        idOperation: props.match.params.idOperation,
      });
      setEndorsementType(data.ret_value.endorsmentType);
      setIsFramework(data.ret_value.isFramework);
      setFullyLoaded(true);
    })
      .catch((error) => {
        // mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  const verifyRequired = (fieldName) => {
    if (!questions) {
      return false;
    }
    const question = questions.find(item => item.dsQuestion === fieldName);
    if (question) {
      if (question?.behavior) {
        try {
          let e = JSON.parse(question.behavior);
          return e.isRequired;
        } catch { return false; };
      }
      return false;
    }
    return false;
  };

  const verifyDisabled = (fieldId) => {
    if (!questions) {
      return false;
    }

    const question = questions.find(item => item.idQuestion === fieldId);
    if (question) {
      return question.disabled;
    }
    return false;
  };

  function validate() {
    let isValid = true;

    for (const i of questions) {
      for (const [index, facility] of facilities.entries()) {
        if (!formik.current.values[`addHoldingAddress_${index}`] || formik.current.values[`addHoldingAddress_${index}`] === "") {
          isValid = false;
          break;
        }
      }
    }

    if (!isValid) {
      mc.error('Please fill in all required fields.');
      return;
    }

    return isValid;
  }

  function handleGeneratePaymentPack(values, taxes) {
    if (validate() && !isDuplicateQuestions()) {
      loading.start();
      let addHoldingAddress = [];
      let addHoldingAddressThirdParty = [];
      let currenciesLpan = [];
      let fxsRate = [];
      let currenciesGstBrokerage = [];
      let fxRatesGstBrokerage = [];

      // transformanto array de taxas em um array de array de questions presentes no array grouped question que por sua vez e um array de array de questions
      const taxCalculationGroups = taxes.map(tax => tax.groupedQuestions);
      const taxCalculationGroup = taxCalculationGroups.flat();

      for (let [index, facility] of facilities.entries()) {
        addHoldingAddress.push(formik.current.values[`addHoldingAddress_${index}`]);
        addHoldingAddressThirdParty.push(formik.current.values[`addHoldingAddressThirdParty_${index}`]);

        currenciesGstBrokerage.push(formik.current.values[`currencyGstBrokerage_${index}`]);
        fxRatesGstBrokerage.push(formik.current.values[`fxRateGstBrokerage_${index}`]);
      }

      if (hasLloydsOrLirma) {
        for (let [index, facility] of facilities.entries()) {
          currenciesLpan.push(formik.current.values[`currencyLpan_${index}`]);
          fxsRate.push(formik.current.values[`fxRate_${index}`]);
        }
      }

      let addHoldingAddressQuestion = questions.filter(f => f.dsQuestion == 'Add Holding Address?');
      let currencyLpanQuestion = questions.filter(f => f.idQuestion === 1310 && f.idQuestionnaireAnswers);
      let fxRateQuestion = questions.filter(f => f.idQuestion === 1311 && f.idQuestionnaireAnswers);
      let currencyPremiumClosingQuestion = questions.filter(f => f.idQuestion == 1821 && f.answer);
      let fxRatePremiumClosingQuestion = questions.filter(f => f.idQuestion == 1822 && f.answer);
      let addHoldingAddressThirdPartyQuestion = questions.filter(f => f.dsQuestion == 'Add Third Party Holding Address?');

      const body = { questionnaireAnswers: cloneDeep(questionnaire) }

      for (const [indexHolding, holding] of addHoldingAddress.entries()) {
        let findHoldingAddressQuestion = addHoldingAddressQuestion.find((q, index) => index == indexHolding);
        body.questionnaireAnswers.push({
          ...addHoldingAddressQuestion[findHoldingAddressQuestion ? indexHolding : 0],
          answer: holding,
          answerJson: holding,
          idQuestion: 1156,
          idAnswerOption: addHoldingAddressQuestion[findHoldingAddressQuestion ? indexHolding : 0]?.answerOptions.find(answerOpt => answerOpt.answerOptionDescription == holding)?.idAnswerOption
        });
      }

      if (hasLloydsOrLirma) {
        if (currenciesLpan.length) {
          body.questionnaireAnswers = body.questionnaireAnswers.filter(
            qst => !(qst.idQuestion === 1310 && !qst?.idQuestionnaireAnswers)
          );
        }

        for (const [indexCurrency, currency] of currenciesLpan.entries()) {
          if (currencyLpanQuestion[indexCurrency]?.idQuestionnaireAnswers) {
            const currencyQst = body.questionnaireAnswers.find(
              qst => qst.idQuestionnaireAnswers === currencyLpanQuestion[indexCurrency].idQuestionnaireAnswers
            );
            if (currencyQst) {
              currencyQst.answer = currency;
              currencyQst.answerJson = currency;
            }
          } else {
            body.questionnaireAnswers.push({
              answer: currency,
              answerJson: currency,
              idQuestion: 1310
            });
          }
        }

        if (fxsRate.length) {
          body.questionnaireAnswers = body.questionnaireAnswers.filter(
            qst => !(qst.idQuestion === 1311 && !qst?.idQuestionnaireAnswers)
          );
        }

        for (const [indexFx, fxRate] of fxsRate.entries()) {
          if (fxRateQuestion[indexFx]?.idQuestionnaireAnswers) {
            const fxRateQst = body.questionnaireAnswers.find(
              qst => qst.idQuestionnaireAnswers === fxRateQuestion[indexFx].idQuestionnaireAnswers
            );
            if (fxRateQst) {
              fxRateQst.answer = fxRate;
              fxRateQst.answerJson = fxRate;
            }
          } else {
            body.questionnaireAnswers.push({
              answer: fxRate,
              answerJson: fxRate,
              idQuestion: 1311
            });
          }
        }

      }

      for (const [indexcurrenciesGstBrokerage, currencyPremiumClosing] of currenciesGstBrokerage.entries()) {
        body.questionnaireAnswers.push({
          ...currencyPremiumClosingQuestion[indexcurrenciesGstBrokerage],
          answer: currencyPremiumClosing,
          answerJson: currencyPremiumClosing,
          idQuestion: 1821
        });
      }

      for (const [indexFxRatePremiumClosing, fxRatePremiumClosing] of fxRatesGstBrokerage.entries()) {
        body.questionnaireAnswers.push({
          ...fxRatePremiumClosingQuestion[indexFxRatePremiumClosing],
          answer: fxRatePremiumClosing,
          answerJson: fxRatePremiumClosing,
          idQuestion: 1822
        });
      }

      for (const [indexHolding, holding] of addHoldingAddressThirdParty.entries()) {
        let findHoldingAddressThirdParyQuestion = addHoldingAddressThirdPartyQuestion.find((q, index) => index == indexHolding);
        body.questionnaireAnswers.push({
          ...addHoldingAddressThirdPartyQuestion[findHoldingAddressThirdParyQuestion ? indexHolding : 0],
          answer: holding,
          answerJson: holding,
          idQuestion: 1314,
          idAnswerOption: addHoldingAddressThirdPartyQuestion[findHoldingAddressThirdParyQuestion ? indexHolding : 0]?.answerOptions.find(answerOpt => answerOpt.answerOptionDescription == holding)?.idAnswerOption
        });
      }

      for (const [key, section] of Object.entries(SECTIONS)) {
        if (section.isMultiple) {
          let multipleFields = []
          switch (section.name) {
            case 'TAX_CALCULATION':
              multipleFields = cloneDeep(taxCalculationGroup);
              break;
            case 'FEE_PAYABLE_BY':
              multipleFields = cloneDeep(feePayableByGroup);
              break;
            case 'INSURER_TAXES':
              multipleFields = cloneDeep(insurerGroup);
              break;
            default:
              multipleFields = [];
              break;
          }

          multipleFields.map((field) => {
            const rootQuestion = field.find((question) => !question.idQuestionRoot);
            const childrenQuestions = field.filter((question) => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions;
            body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
          })
        }
      }

      body.questionnaireAnswers = body.questionnaireAnswers.filter(question => {
        return ((question?.behaviorObject?.sectionName && SECTIONS[question?.behaviorObject?.sectionName]) || !question?.behaviorObject?.sectionName);
      }).map(question => ({ ...question, idQuestionnaireAnswers: question.idQuestionnaireAnswers || null }))

      let childrenQuestionIds = [];
      for (const question of body.questionnaireAnswers) {
        if ((question.idDomainQuestion === 270 ||
          question.idDomainQuestion === 271 ||
          (question.idDomainQuestion === 44 && typeof question.answer === 'object')
        ) && question.answer) {
          try {
            question.answer = JSON.stringify(question.answer);
          } catch (e) {
          }
        }

        if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
          if (question?.childrenQuestions?.length) {
            const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
            childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
          }
        } else {
          question.childrenQuestions = [];
        }
      }
      buildValidation().validate(values, { abortEarly: false })
        .then(() => {
          useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
        })
        .catch((e) => {
          onValidationError(e, mc, formik, questionnaire, [...taxCalculationGroup, ...feePayableByGroup, ...insurerGroup]);
          loading.stop();
        });
    }
  }

  const generatePaymentDocuments = async (body) => {
    let osnd = formik.current.values.osnd;
    let tax = formik.current.values.tax;
    const fxRateGstBrokerage = formik.current.values.fxRateGstBrokerage_0;
    setStatusIsLoading(true);
    useGeneratePaymentPackV2Request({
      currentPeriod,
      osnd,
      tax,
      idOperation: props.match.params.idOperation,
      fxRateGstBrokerage
    }, null)
      .then(({ data: response }) => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          loading.stop();
          setStatusIsLoading(false);
          return;
        }

        setTimeout(() => {
          getStatusOperation();
        }, 3000);
      }).catch((error) => {
        if (error.response && error.response.data && error.response.data.ret_msg_details) {
          if (error.response.data.ret_msg_details.includes('Payment Pack generation in progress')) {
            mc.error(error.response.data.ret_msg_details);
          } else {
            mc.error("There was an error while saving your payment pack");
          }
        } else {
          mc.error("There was an error while saving your payment pack");
        }
        setStatusIsLoading(false);
        loading.stop();
      });
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  async function getOperationInfo() {
    useOperationInfoRequest().then(({ data: response }) => {
      setOperation(response)
      setIsMas(response.idProduct === 36);
      setIsNewYork(response.idProduct === 47);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data`);
      });
  }

  function getForm() {
    usePaymentConfigurationFormRequest().then(({ data: response }) => {
      if (response.ret_code != 200) {
        mc.error(response.ret_msg_details);
        return;
      }

      setIsClaims(response.ret_value.isClaims);
      setQuestions(response.ret_value.paymentConfigurationQuestions);
      setFacilities(response.ret_value.facilities);
      setCurrentPeriod(response.ret_value.currentPeriod || 1);
      setIsSingapureOffice(response.ret_value.OperationRootIsMas);
      setIsThirdParty(!!response.ret_value.hasThirdParty);
      currentOsnd.current = response.ret_value.osnd || {};

      loadForm(
        {
          paymentConfigurationQuestions: response.ret_value.paymentConfigurationQuestions,
          osnd: response.ret_value.osnd,
          OperationRootIsMas: response.ret_value.OperationRootIsMas,
          hasThirdParty: response.ret_value.hasThirdParty,
        },
        response.ret_value.facilities
      );
      formik.current?.setFieldValue('facilities', response.ret_value.facilities);

    }).catch((error) => {
      mc.error(`There was an error while fetching your data`);
    });
  }

  const handleQuestionnaire = async (data, setQuestionnaireState, isParent = false) => {
    let questionnaire = [];
    questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc,
      ...data.paymentConfiguration
    ];

    if (questionnaire && questionnaire.length > 0) {
      setQuestionnaireAux(JSON.parse(JSON.stringify(questionnaire)));
      questionnaire = TaxCalculationSection.events.handleInitialAdjustments({ questionnaire, setTaxes, periods, insurerGroup });
      questionnaire = handleQuestionsInitialAdjustments(questionnaire, summary.isFramework, isClaims, currentPeriod, isThirdParty);
      questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
      setQuestionnaireState(JSON.parse(JSON.stringify(questionnaire)));
      // setTimeout(() => setIsQuestionnaireLoaded(true), 300)
    }

    const premiumCalculationQst = questionnaire.find((qst) => qst.idQuestion === 1977);
    if (!premiumCalculationQst?.answer || !premiumCalculationQst?.answer?.length || premiumCalculationQst?.answer === "[]") {
      setHasPremiumCalculation(false)
    } else {
      setHasPremiumCalculation(true)
    }
  };

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value, setQuestionnaire);
    }
  }, [useGetQuestionnairesAnswersStatus, useOperationInfoStatus, useHeaderNbiLoading, usePaymentConfigurationFormLoading, isClaims, summary?.isFramework, isThirdParty]);

  const verifyOptions = (fieldName, optionAnswer) => {
    if (!questions) {
      return [];
    }

    const field = questions.find(f => f.dsQuestion == fieldName);

    if (field) {
      if (field.answerOptions) {
        return fieldRenderOptions(!optionAnswer ? field.answerOptions : field.answerOptions.filter(f => f.answerOptionDescription === optionAnswer));
      } else {
        return [];
      }
    }

    return [];
  };

  const fieldRenderOptions = function (answerOptions) {
    let result = [];
    answerOptions.forEach(element => {
      result.push({
        label: element.answerOptionDescription,
        value: {
          idAnswerOption: element.idAnswerOption,
          answerOptionDescription: element.answerOptionDescription
        }
      });
    });
    return result;
  };

  const searchRequestCurrency = () => {
    try {
      usePersonListRequest({
        id: 'fitGetCurrencies',
        params: {
          id: 'fitGetCurrencies',
          idProduct: null
        }
      }, null).then(({ data }) => {
        if (data.ret_code != 200) {
          return;
        }
        setSearchList(data.ret_value.map((currency) => ({
          label: currency.currencyCode,
          value: {
            idAnswerOption: currency.currencyId,
            answerOptionDescription: currency.currencyCode
          }
        })));
      });
    } catch (err) {
      console.log("FETCH_FAILURE: ", err);
    }
  };

  const onCurrencyChange = (originCurrency, destinyCurrency, index) => {
    try {
      useFxRatesRequest(null, { originCurrency: originCurrency, destinyCurrency: destinyCurrency }).then(({ data }) => {
        if (data.ret_code !== 200) {
          return;
        }

        if (data.situation === "Not Found") {
          formik.current?.setFieldValue(`fxRate_${index}`, "Not Found");
          setIsAbleToGeneratePaymentPack(false);
        } else {
          formik.current?.setFieldValue(`fxRate_${index}`, data.ret_value);
          setIsAbleToGeneratePaymentPack(true);
          verifyPremiumCalculation(questionnaire);
        }
      });
    } catch (error) {
      mc.error("There was an error while fetching your data");
      console.error('fitPostListContact - Error:', error);
      console.log("FETCH_FAILURE: ", error);
    }
  };

  const EndorsementList = function (values, setFieldValue) {
    if (!periods || !periods.length) return <div />;

    const somePeriodIsLloydsOrLirma = periods.some(period => period.isLloyds || period.isLirma);

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>
              <GridColumnTitle>
                Insurer
              </GridColumnTitle>
            </TableHeader>
            <TableHeader>
              <GridColumnTitle>
                Facility
              </GridColumnTitle>
            </TableHeader>
            <TableHeader>
              <GridColumnTitle>
                DP <br /> Coverage Period
              </GridColumnTitle>
            </TableHeader>
            <TableHeader>
              <GridColumnTitle>
                AP <br /> Coverage Period
              </GridColumnTitle>
            </TableHeader>
            <TableHeader>
              <GridColumnTitle>
                Payment Date
              </GridColumnTitle>
            </TableHeader>
            <HasPermission permission={somePeriodIsLloydsOrLirma}>
              <TableHeader>
                <GridColumnTitle>
                  Box 20 - Tax
                </GridColumnTitle>
              </TableHeader>
              <TableHeader>
                <GridColumnTitle>
                  DP OSND
                </GridColumnTitle>
              </TableHeader>
              <TableHeader>
                <GridColumnTitle>
                  AP OSND
                </GridColumnTitle>
              </TableHeader>
            </HasPermission>
          </TableRow>
        </TableHead>
        <TableBody>
          {periods.map((period, index) => (
            <TableRow index={index}>
              <TableCollum style={{ maxWidth: 120 }}>
                <InlineLabel>
                  Insurer
                </InlineLabel>
                <LabelEdit>
                  {period?.insurer}
                </LabelEdit>
              </TableCollum>

              <TableCollum style={{ maxWidth: 120 }}>
                <InlineLabel>
                  Facility
                </InlineLabel>
                <LabelEdit>
                  {period?.facilityInfo?.facilityName}
                </LabelEdit>
              </TableCollum>

              <TableCollum style={{ maxWidth: 80 }}>
                <InlineLabel>
                  Deposit Premium - Coverage Period
                </InlineLabel>
                <LabelEdit>
                  {period?.coveragePeriodFrom} - {period?.coveragePeriodTo}
                </LabelEdit>
              </TableCollum>

              <TableCollum style={{ maxWidth: 80 }}>
                <InlineLabel>
                  Adjustment Premium - Coverage Period
                </InlineLabel>
                <LabelEdit>
                  {period?.coveragePeriodFromAp} - {period?.coveragePeriodToAp}
                </LabelEdit>
              </TableCollum>

              <TableCollum>
                <InlineLabel>
                  Payment Date
                </InlineLabel>
                <LabelEdit>
                  {period?.dpPaymentDate}
                </LabelEdit>
              </TableCollum>

              <HasPermission permission={period.isLloyds || period.isLirma}>
                <TableCollum>
                  <InlineLabel>
                    Box 20 - Tax
                  </InlineLabel>
                  <Field
                    style={{ width: '100%' }}
                    name={`tax.dpTax.${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`}
                    value={values?.tax?.dpTax?.[`${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`]}
                    onChange={(e) => setFieldValue(`tax.dpTax.${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`, e)}
                    component={InputField}
                    mask={maskHelper.getMask("currency", authContext.region, 2, null, null, 0)}
                  />
                </TableCollum>

                <TableCollum>
                  <InlineLabel>
                    DP OSND
                  </InlineLabel>
                  <Field
                    style={{ width: '100%' }}
                    name={`osnd.dpOsnd.${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`}
                    value={values?.osnd?.dpOsnd?.[`${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`]}
                    onChange={(e) => setFieldValue(`osnd.dpOsnd.${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`, e)}
                    component={InputField}
                  />
                </TableCollum>

                <TableCollum>
                  <InlineLabel>
                    AP OSND
                  </InlineLabel>
                  <Field
                    style={{ width: '100%' }}
                    name={`osnd.apOsnd.${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`}
                    value={values?.osnd?.apOsnd?.[`${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`]}
                    onChange={(e) => setFieldValue(`osnd.apOsnd.${period?.facilityInfo?.idQuestionnaireAnswer}-${period.idPersonInsurerLegalEntity}`, e)}
                    component={InputField}
                  />
                </TableCollum>
              </HasPermission>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  function getStatusOperation() {
    useGeneratePaymentPackStatusRequest().then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details || 'There was an error while processing your data, please try again');
        loading.stop();
        setStatusIsLoading(false);
        return;
      }

      if (data.ret_value.errorMessage && data.ret_value.errorMessage.trim().length) {
        mc.error(data.ret_value.errorMessage || 'There was an error while processing your data, please try again');
        loading.stop();
        setStatusIsLoading(false);
        return;
      }

      if (data.ret_value.statusOperation === 'created') {
        if (summary.isFramework) {
          return history.push(`/broking/payment-pack-send-approval/${props.match.params.idOperation}`)
        } else {
          return history.push(`/broking/payment-pack-send-client-insurer/${props.match.params.idOperation}`)
        }
      };

      setTimeout(() => {
        getStatusOperation();
      }, 3000);

    }).catch((error) => {
      loading.stop();
      setStatusIsLoading(false);
      mc.error("There was an error while fetching your data");
      console.error('fitPostListContact - Error:', error);
    });
  }

  function handlePeriodsSchedulle() {
    if (isClaims) return;

    useProcessingPeriodsScheduleRequest(null, { currentPeriod: currentPeriod }).then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      const osndPeriods = (Object.keys(currentOsnd.current).length !== 0) ? currentOsnd.current : data.osnd || {};
      setPeriods(data.ret_value.filter(period => period.period === 'Current'));
      loadFormOsnd({ osnd: osndPeriods });
      useGetQuestionnairesAnswersRequest()
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data`);
        console.error('PeriodsSchedule - Error:', error);
      });
  }

  function loadForm(data, facilitiesParam) {

    let values = {
      ...formik.current.values,
    };

    formik.current.setValues(values);

    const holdingAddress = data?.paymentConfigurationQuestions?.filter(x => x.idQuestion === 1156);

    for (const [indexFacility, fac] of facilitiesParam.entries()) {
      for (const [indexHoldingAddress, holding] of holdingAddress.entries()) {
        if (indexFacility === indexHoldingAddress && holding.answer) {
          formik.current.values[`addHoldingAddress_${indexFacility}`] = holding.answer == 'Yes' ? 'Yes' : 'No';
        } else if (indexHoldingAddress == indexFacility || !holdingAddress[indexFacility]) {
          formik.current.values[`addHoldingAddress_${indexFacility}`] = 'No';
        }
      }
    }

    const currencyLpanAnswer = data?.paymentConfigurationQuestions?.filter(x => x.dsQuestion == 'Currency (LPAN)');
    const fxRateAnswer = data?.paymentConfigurationQuestions?.filter(x => x.dsQuestion == 'FX Rate');

    if (data.hasThirdParty) {
      const thirdPartyPayingQuestion = data?.paymentConfigurationQuestions?.find(x => x.idQuestion == 1824);

      thirdPartyPayingQuestion.answer
        ? formik.current.values[`thirdPartyPaying`] = thirdPartyPayingQuestion.answer == 'Yes' ? 'Yes' : 'No'
        : formik.current.values[`thirdPartyPaying`] = 'No';
    }

    for (const [indexFacility, fac] of facilitiesParam.entries()) {
      for (const [indexCurrencyLPAN, currencyLPAN] of currencyLpanAnswer.entries()) {
        if (indexCurrencyLPAN === indexFacility && currencyLPAN.answer) {
          formik.current.values[`currencyLpan_${indexFacility}`] = currencyLPAN.answer;
          formik.current.values[`fxRate_${indexFacility}`] = fxRateAnswer[indexFacility].answer;
        } else if (indexCurrencyLPAN == indexFacility || !currencyLpanAnswer[indexFacility]) {
          formik.current.values[`currencyLpan_${indexFacility}`] = fac.currency;
          formik.current.values[`fxRate_${indexFacility}`] = 1.00000;
        }
      }

      if (data.OperationRootIsMas) {
        const currencyGstBrokerageAnswer = data?.paymentConfigurationQuestions?.filter(x => x.idQuestion == 1821);
        const fxRateGstBrokerageAnswer = data?.paymentConfigurationQuestions?.filter(x => x.idQuestion == 1822);
        for (const [indexFacility, fac] of facilitiesParam.entries()) {
          for (const [indexCurrencyGstBrokerage, currencyGstBrokerage] of currencyGstBrokerageAnswer.entries()) {
            if (indexCurrencyGstBrokerage === indexFacility && currencyGstBrokerage.answer) {
              formik.current.values[`currencyGstBrokerage_${indexFacility}`] = currencyGstBrokerage.answer;
              formik.current.values[`fxRateGstBrokerage_${indexFacility}`] = fxRateGstBrokerageAnswer[indexFacility].answer;
            } else if (indexCurrencyGstBrokerage == indexFacility || !currencyGstBrokerageAnswer[indexFacility]) {
              formik.current.values[`currencyGstBrokerage_${indexFacility}`] = fac.currency;
              formik.current.values[`fxRateGstBrokerage_${indexFacility}`] = fac.fxRateGstBrokerage;
            }
          }
        }
      }
    }

    const holdingAddressThirdParty = data?.paymentConfigurationQuestions?.filter(x => x.idQuestion === 1314);

    for (const [indexFacility, fac] of facilitiesParam.entries()) {
      for (const [indexHoldingAddressThirdParty, holding] of holdingAddressThirdParty.entries()) {
        if (indexFacility === indexHoldingAddressThirdParty && holding.answer) {
          formik.current.values[`addHoldingAddressThirdParty_${indexFacility}`] = holding.answer == 'Yes' ? 'Yes' : 'No';
        } else if (indexHoldingAddressThirdParty == indexFacility || !holdingAddressThirdParty[indexFacility]) {
          formik.current.values[`addHoldingAddressThirdParty_${indexFacility}`] = 'No';
        }
      }
    }
  }

  function loadFormOsnd(data) {
    let values = {
      ...formik.current.values,
      osnd: data?.osnd,
    };

    formik.current.setValues(values);
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleSummary();
    getForm();
    searchRequestCurrency();
    getOperationInfo();
    useGetQuestionnairesAnswersRequest();

    useGeneratePaymentPackStatusRequest().then(({ data }) => {
      setIsBound([494, 62].includes(data?.ret_value?.idDomainStatus))
      setCanCancel(!data?.ret_value?.idDomainStatus)
    }).catch((error) => {
      console.error('fitPostListContact - Error:', error);
    })
  }, []);

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      useDeleteQuestionnaireAnswerRequest({ ids: questionnaireAnswersToDelete })
        .then(() => {
          if (operation.idDomain === 27 || (operation?.idDomain === 410 && operation?.metadata?.quotationOperationId)) {
            useSyncQuestionnaireAnswerRequest({
              idOperationOrigin: Number(props.match.params.idOperation),
              idOperation: operation?.idDomain === 410 && operation?.metadata?.quotationOperationId ? Number(operation?.metadata?.quotationOperationId) : Number(operation.idOperationRoot),
              onlyFromThisSections: ['TAX_RATES', 'INSURER_TAXES', 'FEE_PAYABLE_BY']
            });
          }

          useGetQuestionnairesAnswersRequest()
          if (isPaymentPackButtonClicked.current) {
            generatePaymentDocuments();
          }
        });
    }

    if (useSaveQuestionnaireAnswerStatus === 400) {
      useSaveQuestionnaireAnswerError.errors?.map(error => {
        if (error.message) mc.error(error.message);
      });
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  useEffect(() => {
    if ((!isFramework && currentPeriod && hasPremiumCalculation) || operation?.idDomain === 396) {
      handlePeriodsSchedulle();
    }
  }, [isFramework, currentPeriod, hasPremiumCalculation, operation]);

  useEffect(() => {
    setHasLloydsOrLirma(() => {
      const period = periods.find(period => period?.isLloyds || period?.isLirma);
      return period?.isLloyds || period?.isLirma ? true : false;
    });
  }, [periods]);

  useEffect(() => {
    if (endorsementType === 'pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM PRE AGREED / PAYMENT CONFIGURATION",
        route: ''
      });
    } else if (endorsementType === 'not-pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM NOT PRE AGREED / PAYMENT CONFIGURATION",
        route: ''
      });
    } else if (endorsementType === 'off-risk') {
      return;
    } else if (endorsementType === 'cancellation') {
      setStatusEndorsement({
        title: "ENDORSEMENT - CANCELLATION / PAYMENT CONFIGURATION",
        route: ''
      });
    } else if (endorsementType === 'market-changes') {
      setStatusEndorsement({
        title: "RISK & MARKET CHANGES / PAYMENT CONFIGURATION",
        route: ''
      });
    }
  }, [endorsementType]);

  const verifyPaymentMethod = ({ paymentMethod }) => {
    if (paymentMethod && paymentMethod.answerOptionDescription === 'Direct Insurer Payment') {
      formik.current.values.paymentRebate = true;
      return true;
    }

    return false;
  };

  const handleSaveQuestionnaireAnswer = (idOperation, onlyQuestions, taxCalculationGroup = []) => {
    const body = { questionnaireAnswers: cloneDeep(questionnaire) }

    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = [];
        switch (section.name) {
          case 'TAX_CALCULATION':
            multipleFields = cloneDeep(taxCalculationGroup);
            break;
          case 'FEE_PAYABLE_BY':
            multipleFields = cloneDeep(feePayableByGroup);
            break;
          case 'INSURER_TAXES':
            multipleFields = cloneDeep(insurerGroup);
            break;
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map((group) => {
          const rootQuestion = group.find((question) => !question.idQuestionRoot);
          const childrenQuestions = group.filter((question) => question.idQuestionRoot);
          rootQuestion.childrenQuestions = childrenQuestions;
          if (!onlyQuestions) {
            body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
          } else {
            body.questionnaireAnswers = [...body.questionnaireAnswers, ...group];
          }
        })
      }
    }

    for (const question of body.questionnaireAnswers) {
      if ((question.idDomainQuestion === 270 ||
        question.idDomainQuestion === 271 ||
        (question.idDomainQuestion === 44 && typeof question.answer === 'object')
      ) && question.answer) {
        try {
          question.answer = JSON.stringify(question.answer);
        } catch (e) {
        }
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  };

  const buildValidation = () => {
    const validationSchema = {};

    const questionnaire = handleSaveQuestionnaireAnswer(false, true);

    for (const question of questionnaire) {
      if (!question.key) continue;
      if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;
      validationSchema[question.key] = question.visibleQuestion && !question.answer && question.behaviorObject.isRequired
        ? yup.string().required()
        : yup.string().notRequired().nullable();
    }

    return yup.object().shape(validationSchema);
  };

  const isDuplicateQuestions = () => {
    let allTaxesGrouped = questionnaire.find((question) => question.idQuestion === 1377)?.answer;

    let hasDuplicatedTax = false;
    let taxNames = [];

    if (allTaxesGrouped === "Yes") {
      for (const taxes of insurerGroup) {
        if (taxNames.includes(taxes.find((tax) => tax.idQuestion === 1380)?.answer)) {
          hasDuplicatedTax = false;  //todo: revert
        } else {
          taxNames.push(taxes.find((tax) => tax.idQuestion === 1380)?.answer);
        }
      }
    } else {
      for (const taxes of insurerGroup) {
        const question = taxes.find((question) => question.idQuestion === 1378);
        let obj = {
          nameInsurer: JSON.parse(question.answer)?.value,
          nameFacility: JSON.parse(taxes.find((tax) => tax.idQuestion === 1379)?.answer)?.value,
          taxName: JSON.parse(taxes.find((tax) => tax.idQuestion === 1380)?.answer)?.value,
        };

        if (!taxNames.length) {
          taxNames.push(obj);
        } else {
          let alreadyExistsTax = taxNames.find(
            (tax) => tax.nameInsurer === obj.nameInsurer && tax.nameFacility === obj.nameFacility && tax.taxName === obj.taxName
          );

          if (!alreadyExistsTax) {
            taxNames.push(obj);
          } else {
            hasDuplicatedTax = false; //todo: revert
          }
        }
      }
    }

    if (hasDuplicatedTax) {
      mc.error("Duplicate taxes for the same insurer are not allowed!");
    }

    return hasDuplicatedTax;
  }

  const verifyPremiumCalculation = (questionnaire) => {
    if (isFramework || isClaims || operation?.idDomain === 396) return setIsAbleToGeneratePaymentPack(true);

    const scheduleAttachment = questionnaire.find((question) => question.idQuestion === 1977);
    if (!scheduleAttachment?.answer || !scheduleAttachment?.answer?.length || scheduleAttachment?.answer === "[]") return setIsAbleToGeneratePaymentPack(false);

    setIsAbleToGeneratePaymentPack(true);
  };

  const refreshTaxes = () => {
    if (isDuplicateQuestions()) return;

    const taxCalculationGroups = taxes.map(tax => tax.groupedQuestions);
    const taxCalculationGroup = taxCalculationGroups.flat();

    const arrayToDelete = taxCalculationGroup.flatMap((q) =>
      q.filter((question) => question.idQuestionnaireAnswers).map((question) => question.idQuestionnaireAnswers)
    )

    setQuestionnaireAnswersToDelete([...questionnaireAnswersToDelete, ...arrayToDelete]);

    const questionnaireAnswers = handleSaveQuestionnaireAnswer(false, true, taxCalculationGroup);
    TaxCalculationSection.events.handleInitialAdjustments({
      questionnaire: questionnaireAnswers,
      questionnaireAux,
      setTaxes,
      periods,
      insurerGroup,
      isRefresh: true
    })
  }

  useEffect(() => {
    verifyPremiumCalculation(questionnaire);
  }, [questionnaire, operation]);

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      {isClaims ? <ClaimsSummary stage={3} idOperation={props.match?.params?.idOperation} />
        : <>
          <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
          <BrokingSummary data={summary} />
        </>}
      <ContentCard
        title={statusEndorsement.title}
        icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

        <Formik
          innerRef={formik}
          initialValues={{
            paymentRebate: false,
            paymentDPAndAP: true,
            clientReference: '',
            facilities: []
          }}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          onSubmit={(values) => handleGeneratePaymentPack(values, taxes)}
          render={({ values, setFieldValue, setFieldError, errors, ...formikProps }) => {
            return (
              <>
                <HasPermission permission={!isFramework && operation?.idDomain !== 396 && !isClaims}>
                  <PremiumCalculationSection
                    formikRef={formik}
                    questionnaire={questionnaire}
                    setQuestionnaire={setQuestionnaire}
                    values={values}
                    errors={errors}
                    disableAll={isBound}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    idOperation={operation?.idDomain === 27 ? operation?.idOperationParent : (operation?.idDomain === 410 && operation?.metadata?.quotationOperationId) ? operation?.metadata?.quotationOperationId : props.match.params.idOperation}
                    idOperationParent={props.match.params.idOperationParent}
                    path={props?.path}
                    onRemove={useExpirePaymentPackRequest}
                    permissions={props.routePermissions}
                    useGetQuestionnaireAnswerRequest={useGetQuestionnairesAnswersRequest}
                    useSaveQuestionnaireAnswerRequest={useSaveQuestionnaireAnswerRequest}
                    currentPeriod={currentPeriod}
                    questionsIdsToSave={[1977]}
                    hideExportButton={operation?.idDomain === 400 || operation?.idDomain === 398}
                  />
                </HasPermission>
                <Form>
                  <HasPermission
                    permission={(!isClaims && !isFramework) && (hasPremiumCalculation || operation?.idDomain === 396)}
                  >
                    <FormContainer title="Taxes" collapsedAtStart>
                      <TaxesRatesBasisGroupSection.components.RenderSection
                        values={values}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        setFieldError={setFieldError}
                        formikRef={formik}
                        idProduct={operation?.idProduct}
                        idOperation={props.match.params.idOperation}
                        idOperationParent={props.match.params.idOperationParent}
                        globalQuestionnaire={questionnaire}
                        setGlobalQuestionnaire={setQuestionnaire}
                        questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                        setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                        useGetQuestionnairesAnswersData={useGetQuestionnairesAnswersData}
                        useGetQuestionnairesAnswersStatus={useGetQuestionnairesAnswersStatus}
                        operation={operation}
                        loading={loading}
                        mc={mc}
                        recalculateButton={true}
                        insurerGroup={insurerGroup}
                        feePayableByGroup={feePayableByGroup}
                        setInsurerGroup={setInsurerGroup}
                        setFeePayableByGroup={setFeePayableByGroup}
                        disableAll={isBound}
                        refreshTaxes={refreshTaxes}
                        setTaxesLoading={setTaxesLoading}
                      />
                    </FormContainer>
                  </HasPermission>
                  <HasPermission
                    permission={(!isClaims && !isFramework) && (hasPremiumCalculation || operation?.idDomain === 396)}
                  >
                    <TaxCalculationSection.components.RenderSection
                      disableAll={isBound}
                      formikRef={formik}
                      idOperation={props.match?.params?.idOperation}
                      idOperationParent={props.match?.params?.idOperationParent}
                      idProduct={operation?.idProduct}
                      taxes={taxes}
                      errors={errors}
                      setFieldError={setFieldError}
                      setFieldValue={setFieldValue}
                      values={values}
                      setTaxes={setTaxes}
                    />
                  </HasPermission>
                  <Col md={8}>
                    <FormSection
                      sectionName="PAYMENT_CONFIG"
                      formikRef={formik}
                      disableAll={isBound}
                      onQuestionnaireChange={filteredQuestionnaire => setQuestionnaire(filteredQuestionnaire)}
                      questionnaire={questionnaire}
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                      setFieldError={setFieldError}
                      setQuestionnaire={setQuestionnaire}
                      idOperation={props.match?.params?.idOperation}
                      onQuestionChange={(question, value, setFieldValue, questionnaireUpdated) =>
                        handleQuestionChange(question, value, questionnaireUpdated, setQuestionnaire, setFieldValue
                        )}
                    />
                  </Col>
                  {isSingapureOffice && <>
                    <Col md={5}>
                      <Label1>Currency for GST on Brokerage (document only)</Label1>
                      <Row style={{ display: "inline-flex", justifyContent: "space-between", width: "100%" }}>
                        <Label1 style={{ paddingTop: '10px', width: "33%" }}>Facility Name</Label1>
                        <Label1 style={{ paddingTop: '10px', width: "33%" }}>Currency</Label1>
                        <Label1 style={{ paddingTop: '10px', width: "33%" }}>FX Rate</Label1>
                      </Row>
                    </Col>
                    {values?.facilities.map((facility, index) => (
                      <Col md={5} key={index}>
                        <Row style={{ display: "inline-flex", justifyContent: "space-between", width: "100%" }}>
                          <Label1 style={{ paddingTop: '10px', width: "33%" }}>{facility?.facility_name}</Label1>
                          <Field
                            style={{ width: "33%" }}
                            type="text"
                            name={`currencyGstBrokerage_${index}`}
                            value={values[`currencyGstBrokerage_${index}`]}
                            onChange={(e) => {
                              if (((e?.answerOptionDescription) && (values?.facilities[index].currency !== e.answerOptionDescription || e.answerOptionDescription !== values[`currencyGstBrokerage_${index}`]))) {
                                setFieldValue(`currencyGstBrokerage_${index}`, e.answerOptionDescription);
                                onCurrencyChange(values?.facilities[index].currency, e.answerOptionDescription, index);
                              } else {
                                setFieldValue(`currencyGstBrokerage_${index}`, values[`currencyGstBrokerage_${index}`]);
                              }
                            }}
                            searchList={searchList}
                            options={verifyOptions("Currency (GST on Brokerage)")}
                            isRequired={verifyRequired('Currency (GST on Brokerage)')}
                            component={ComboBox3}
                            placeholder={values[`currencyGstBrokerage_${index}`]}
                            disabled={verifyDisabled(1821)}
                            readOnly
                          />
                          <Field
                            style={{ width: "33%" }}
                            name={`fxRateGstBrokerage_${index}`}
                            value={values[`fxRateGstBrokerage_${index}`]}
                            component={InputField}
                            mask={maskHelper.getMask("currency", authContext.region, 5, null, null, 0)}
                          />
                        </Row>
                      </Col>
                    ))}
                  </>
                  }

                  {hasLloydsOrLirma ? <>
                    <Col md={5}>
                      <Label1>Currency for LPAN (document only)</Label1>
                      <Row style={{ display: "inline-flex", justifyContent: "space-between", width: "100%" }}>
                        <Label1 style={{ paddingTop: '10px', width: "33%" }}>Facility Name</Label1>
                        <Label1 style={{ paddingTop: '10px', width: "33%" }}>Currency</Label1>
                        <Label1 style={{ paddingTop: '10px', width: "33%" }}>FX Rate</Label1>
                      </Row>
                    </Col>
                    {values?.facilities?.map((facility, index) => (
                      <Col md={5} key={index}>
                        <Row style={{ display: "inline-flex", justifyContent: "space-between", width: "100%" }}>
                          <Label1 style={{ paddingTop: '10px', width: "33%" }}>{facility?.facility_name}</Label1>
                          <Field
                            readOnly
                            style={{ width: "33%" }}
                            type="text"
                            name={`currencyLpan_${index}`}
                            value={values[`currencyLpan_${index}`]}
                            onChange={(e) => {
                              if (((e?.answerOptionDescription) && (values?.facilities[index].currency != e.answerOptionDescription || e.answerOptionDescription != values[`currencyLpan_${index}`]))) {
                                setFieldValue(`currencyLpan_${index}`, e.answerOptionDescription);
                                onCurrencyChange(values?.facilities[index].currency, e.answerOptionDescription, index);
                              } else {
                                setFieldValue(`currencyLpan_${index}`, values[`currencyLpan_${index}`]);
                              }
                            }}
                            searchList={searchList}
                            options={verifyOptions("Currency (LPAN)")}
                            isRequired={verifyRequired('Currency (LPAN)')}
                            component={ComboBox3}
                            placeholder={values[`currencyLpan_${index}`]}
                            disabled={verifyDisabled(1310)}
                          />
                          <Field
                            style={{ width: "33%" }}
                            name={`fxRate_${index}`}
                            value={values[`fxRate_${index}`]}
                            component={InputField}
                            mask={maskHelper.getMask("currency", authContext.region, 5, null, null, 0)}
                            disabled={true}
                          />
                        </Row>
                      </Col>
                    ))}
                  </> : <></>}

                  {values?.facilities?.map((facility, index) => (
                    <Row style={{ marginBottom: '20px' }}>
                      <Col md={3} key={index}>
                        {index === 0 && <Label1>* Add Holding Address?</Label1>}
                        <Label1 style={{ paddingTop: '10px' }}>Facility Name: {facility?.facility_name}</Label1>
                        <Row>
                          <Field
                            label={"Yes"}
                            name={`addHoldingAddress_${index}`}
                            options={verifyOptions("Add Holding Address?", "Yes")}
                            value={values[`addHoldingAddress_${index}`]}
                            onChange={(e) => {
                              setFieldValue(`addHoldingAddress_${index}`, e);
                            }}
                            option={"Yes"}
                            component={RadioButton}
                            style={{ paddingRight: "30px" }}
                          />
                          <Field
                            label={"No"}
                            name={`addHoldingAddress_${index}`}
                            options={verifyOptions("Add Holding Address?", "No")}
                            value={values[`addHoldingAddress_${index}`]}
                            onChange={(e) => {
                              setFieldValue(`addHoldingAddress_${index}`, e);
                            }}
                            option={"No"}
                            component={RadioButton}
                          />
                        </Row>
                      </Col>
                      <Col md={3} key={index}>
                        {index === 0 && <Label1>Add Third Party Holding Address?</Label1>}
                        <Label1 style={{ paddingTop: '10px' }}>Facility Name: {facility?.facility_name}</Label1>
                        <Row>
                          <Field
                            label={"Yes"}
                            name={`addHoldingAddressThirdParty_${index}`}
                            options={verifyOptions("Add Third Party Holding Address?", "Yes")}
                            value={values[`addHoldingAddressThirdParty_${index}`]}
                            onChange={(e) => {
                              setFieldValue(`addHoldingAddressThirdParty_${index}`, e);
                            }}
                            option={"Yes"}
                            component={RadioButton}
                            style={{ paddingRight: "30px" }}
                          />
                          <Field
                            label={"No"}
                            name={`addHoldingAddressThirdParty_${index}`}
                            options={verifyOptions("Add Third Party Holding Address?", "No")}
                            value={values[`addHoldingAddressThirdParty_${index}`]}
                            onChange={(e) => {
                              setFieldValue(`addHoldingAddressThirdParty_${index}`, e);
                            }}
                            option={"No"}
                            component={RadioButton}
                          />
                        </Row>
                      </Col>
                    </Row>
                  ))}

                  {EndorsementList(values, setFieldValue)}

                  {(isMas || isNewYork) && (
                    <Row style={{ marginTop: '20px' }}>
                      <Col md={12} sm={12} lg={12} xs={12}>
                        <Label style={{ fontSize: '8px' }}>
                          Fitinsur Desenvolvimento e Licenciamento de Sistemas Ltda. ("fitinsur") declares that the exchange rates
                          presented herein are provided by TEXEL FINANCE LIMITED incorporated and registered in England and Wales with
                          company number 03454026 whose registered office is at Gable House, 239 Regents Park Road, London, United Kingdom,
                          N3 3LF. The customer must confirm the rates in force before carrying out any transactions that may be affected
                          by changes in the exchange rate(s). In addition, fitinsur (a) does not validate the data and waives any obligation
                          to do so; (b) makes no warranty as to the accuracy, adequacy or completeness of any data and (c) under no circumstances
                          shall be liable for any errors, omissions or other failures, delays or interruptions related to such data,
                          nor for any actions taken on the basis thereof.
                        </Label>
                      </Col>
                    </Row>
                  )}
                  <ButtonContainer>
                    <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                    <RenderButtons idOperation={props.match?.params?.idOperation}>
                      <ButtonContent>
                        <HasPermission permission={operation?.idDomain === 396 && canCancel}>
                          <div style={{ marginTop: "5px" }}>
                            <LostCancelButton idOperation={props.match?.params?.idOperation} />
                          </div>
                        </HasPermission>
                        <HasPermission permission={props.permissions.PAYMENT_PACK_CREATE && !isBound}>
                          <Button
                            disabled={!isAbleToGeneratePaymentPack && !isClaims && !isFramework}
                            style={{ marginLeft: "30px", marginTop: "5px" }}
                            primary
                            type="submit"
                            id="btnSubmitSend"
                            onClick={() => isPaymentPackButtonClicked.current = true}
                          >
                            GENERATE PAYMENT PACK
                          </Button>
                        </HasPermission>
                      </ButtonContent>
                    </RenderButtons>
                  </ButtonContainer>
                </Form>
              </>
            )
          }}
        >
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout >
  );
}